import { Job, OurJobStatus, OurJobStatusDropdownChoices } from "./types";
import { Option } from "../../components/tailwind/dropdown/Dropdown";

const friendlyJobStatusMap: Record<OurJobStatus, string> = {
  NO_PARENT_TASK: "Waiting to start",
  UNDETERMINED: "Undetermined",
  PENDING: "Pending",
  RECEIVED: "Received",
  STARTED: "Started",
  SUCCESS: "Success",
  FAILURE: "Failure",
  REVOKED: "Cancelled",
  REJECTED: "Rejected",
  RETRY: "Retry",
};

export function friendlyStatus(status: OurJobStatus): string {
  return friendlyJobStatusMap[status];
}

const jobStatusDropdownChoices: Record<OurJobStatusDropdownChoices, string> = {
  NO_PARENT_TASK: "Waiting to start",
  PENDING: "Pending",
  SUCCESS: "Success",
  FAILURE: "Failure",
};

export const jobStatusDropdownItems: Option<
  OurJobStatusDropdownChoices
>[] = Object.entries(jobStatusDropdownChoices).map(([key, value]) => ({
  key,
  value: key as OurJobStatusDropdownChoices,
  text: value,
}));

export const findRetryableDocumentIds = (job: Job): string[] => {
  const summary = job?.summary;
  if (!summary) return [];
  return Object.values(summary)
    .filter(
      (row) =>
        row.last_report?.resource_type === "Product" &&
        "reason" in row.last_report
    )
    .map((row) => row.last_report.resource_id as string);
};
